<template>
  <v-container class="my-tests">
    <div class="d-flex flex-wrap align-center my-tests__head">
      <h1 class="my-tests__title">Мої тести</h1>
      <v-btn depressed color="primary" :href="testsUrl">Усі тести</v-btn>
    </div>

    <div v-if="loading" class="text-center py-10">
      <v-progress-circular indeterminate color="primary" size="40"></v-progress-circular>
    </div>

    <div v-else-if="!items.length" class="my-tests__empty">
      <p>Тут зберігаються результати професійних тестів і опитувальників, які ви пройшли на сайті, увійшовши в кабінет. Результати тестів, які рекомендував психолог, він теж бачить у чаті.</p>
      <v-btn depressed outlined color="primary" :href="testsUrl">Перейти до тестів</v-btn>
    </div>

    <div v-for="item in items" v-else :key="item.id" class="my-tests__card">
      <div class="d-flex flex-wrap align-center my-tests__meta">
        <span>{{ dateOf(item.created_at) }}</span>
        <span v-if="item.psychologist">Надіслано психологу: {{ item.psychologist }}</span>
      </div>
      <div class="my-tests__name">{{ item.test ? item.test.title : "Тест" }}</div>
      <div v-for="(score, s) in item.scores" :key="s" class="my-tests__score">
        <span v-if="score.title" class="my-tests__scale">{{ score.title }}:</span>
        <b>{{ score.score }}</b> з {{ score.max }}<template v-if="score.result_title"> · {{ score.result_title }}</template>
        <div v-if="score.result_text" class="my-tests__text">{{ score.result_text }}</div>
      </div>
      <div class="my-tests__actions">
        <v-btn small depressed outlined color="primary" @click="show(item.id)">Мої відповіді</v-btn>
        <v-btn v-if="item.test" small text color="primary" :href="testsUrl + '/' + item.test.slug">Пройти ще раз</v-btn>
      </div>
    </div>

    <v-dialog v-model="dialog" max-width="640" scrollable>
      <v-card>
        <v-card-title class="d-flex">
          <span style="word-break: normal">{{ result ? result.test.title : "Відповіді" }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="!result" class="text-center py-6"><v-progress-circular indeterminate color="primary"></v-progress-circular></div>
          <ol v-else class="my-tests__answers">
            <li v-for="(answer, a) in result.answers" :key="a">
              <div>{{ answer.question }}</div>
              <div class="my-tests__answer">{{ answer.answer }}</div>
            </li>
          </ol>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ApiClient from "@/libs/http-client";

export default {
  name: "MyTests",
  metaInfo() {
    return { title: "Платформа / Мої тести" };
  },
  data() {
    return {
      loading: true,
      items: [],
      dialog: false,
      result: null,
      testsUrl: (process.env.VUE_APP_MAIN_PAGE || "").replace(/\/$/, "") + "/tests",
    };
  },
  mounted() {
    ApiClient.get("api/patients/tests/results")
      .then((response) => {
        this.items = response.data.data;
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    show(id) {
      this.result = null;
      this.dialog = true;
      ApiClient.get(`api/chat/test-results/${id}`).then((response) => {
        this.result = response.data.data;
      });
    },
    dateOf(value) {
      return new Date(value).toLocaleDateString("uk-UA", { day: "numeric", month: "long", year: "numeric" });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-tests {
  max-width: 900px;
  padding-top: 40px;
  padding-bottom: 60px;
}
.my-tests__head {
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
}
.my-tests__title {
  color: #00A3B7;
  font-size: 25px;
  font-weight: 500;
}
.my-tests__empty {
  padding: 40px 0;
  color: #575756;
  font-size: 17px;
  text-align: center;
}
.my-tests__card {
  margin-bottom: 14px;
  padding: 18px 22px;
  border: 1px solid #D9E4EB;
  border-radius: 12px;
  background: #fff;
  color: #575756;
}
.my-tests__meta {
  gap: 6px 14px;
  color: #868686;
  font-size: 14px;
}
.my-tests__name {
  margin: 8px 0 6px;
  color: #00A3B7;
  font-size: 18px;
  font-weight: 500;
}
.my-tests__score {
  margin-bottom: 6px;
  font-size: 15px;
}
.my-tests__scale {
  color: #868686;
}
.my-tests__text {
  margin-top: 2px;
  font-size: 14px;
}
.my-tests__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}
.my-tests__answers {
  padding-left: 20px !important;
  color: #575756;
  li {
    margin-bottom: 10px;
  }
}
.my-tests__answer {
  color: #00A3B7;
  font-weight: 500;
}
</style>
